// extracted by mini-css-extract-plugin
export default {"item":"cl_gQ","inactiveLink":"cl_j3"};